import React from 'react'
import { connect } from 'react-redux'
import './App.css';
import Menu from './Menu'
import Main from './Main'
import Footer from './Footer'
import Loading from './Loading'
import SessionWarningDialogContainer from '../domains/session/SessionWarningDialogContainer'
import TermsAcceptanceModal from '../domains/terms/TermsAcceptanceModal'
import * as sessionSelectors from '../domains/session/redux/SessionSelectors'
import * as termsSelectors from '../domains/terms/redux/TermsSelectors'

const App = ({ checkingSession, sessionChecked, loggedInUser, termsStatus }) => (
    <div className="App">
        {(!sessionChecked || checkingSession) && <Loading title="Kontrollerar session..."/>}
        <div className="App-header">
            <Menu />
        </div>
        <div className="App-content-wrapper">
            <div className="App-body">
                {loggedInUser && !termsStatus
                    ? <Loading title="Kontrollerar villkor..."/>
                    : <Main />}
            </div>
            <div className="App-footer">
                <Footer />
            </div>
        </div>
        <SessionWarningDialogContainer />
        {loggedInUser && termsStatus && termsStatus.needsAcceptance && <TermsAcceptanceModal />}
    </div>
)

const mapStateToProps = (state) => ({
    checkingSession: sessionSelectors.checkingSession(state),
    sessionChecked: sessionSelectors.sessionChecked(state),
    loggedInUser: sessionSelectors.loggedInUser(state),
    termsStatus: termsSelectors.status(state),
})

export default connect(mapStateToProps)(App)